import React from "react";

import {
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
	FrontendOrganization,
	FrontendOrganizationLicense,
	FrontendSample,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import UserLicenseInfoSection from "./userLicenseInfoSection";

import { CustomRadioGroup } from "../../../common-components/inputs";
import OrgSamplesSection from "./orgSamplesSection";
import OrgSpecificationsSection from "./orgSpecificationsSection";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo | undefined;
	selectedOrganization: FrontendOrganization;

	orgDetailsSelectedCategory: FrontendCompanyTestCategory;
	setOrgDetailsSelectedCategory: React.Dispatch<
		React.SetStateAction<FrontendCompanyTestCategory | undefined>
	>;

	licenses: Array<FrontendOrganizationLicense>;
	setLicenses: React.Dispatch<
		React.SetStateAction<Array<FrontendOrganizationLicense>>
	>;

	samples: Array<FrontendSample>;
	setSamples: React.Dispatch<React.SetStateAction<Array<FrontendSample>>>;

	orgSpecifications: Array<FrontendSampleSpecification>;
	setOrgSpecifications: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecification>>
	>;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
	setSpecDirectories: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecificationDirectory>>
	>;
	reloadOrganizationDetailedInfo: () => void;
	loading: boolean;
}

export default function OrgDetailedCategoryInfoContent(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		user,
		company,
		setCompany,
		orgDetailsSelectedCategory,
		setOrgDetailsSelectedCategory,
		selectedOrganization,
		licenses,
		setLicenses,
		samples,
		setSamples,
		orgSpecifications,
		setOrgSpecifications,
		specDirectories,
		setSpecDirectories,
		reloadOrganizationDetailedInfo,
		loading,
	} = props;

	const filterSelectionOptions: Array<{
		key: string;
		name: string;
		description?: string;
		value: any;
		children?: any;
	}> = company.companyTestCategories.map(
		(option: FrontendCompanyTestCategory) => {
			const name: string = option.testCategoryName;
			return {
				key: option.testCategoryId,
				name: name,
				description: "",
				value: option.testCategoryId,
				children: (
					<div
						className={`center-text status-selection-radio-option typography-body-02 ${
							orgDetailsSelectedCategory.testCategoryId ===
							option.testCategoryId
								? "status-selection-radio-option-selected"
								: ""
						}`}
					>
						{name}
					</div>
				),
			};
		},
	);

	const filterSelection: React.ReactNode = (
		<div
			style={{
				maxWidth: "700px",
				overflowX: "auto",
			}}
		>
			<CustomRadioGroup
				options={filterSelectionOptions}
				selectedOption={orgDetailsSelectedCategory}
				onChange={(e) => {
					const selected = company.companyTestCategories.find((category) => {
						return category.testCategoryId == e.target.value;
					});
					setOrgDetailsSelectedCategory(selected);
				}}
				className="status-selection-radio-group"
			/>
		</div>
	);

	return (
		<div>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexWrap: "wrap",
					gap: "10px",
				}}
			>
				{filterSelection}
			</div>
			{loading ? (
				<></>
			) : (
				<div>
					<UserLicenseInfoSection
						user={props.user as FrontendUserInfo}
						orgDetailsSelectedCategory={orgDetailsSelectedCategory}
						organizationLicenses={licenses}
						setOrganizationLicenses={setLicenses}
						organizationId={selectedOrganization.organizationId}
					></UserLicenseInfoSection>
					<OrgSamplesSection
						user={props.user as FrontendUserInfo}
						selectedTestCategory={orgDetailsSelectedCategory}
						organizationId={selectedOrganization.organizationId}
						organizationSamples={samples}
						setOrganizationSamples={setSamples}
						reloadOrganizationDetailedInfo={reloadOrganizationDetailedInfo}
					></OrgSamplesSection>
					<OrgSpecificationsSection
						company={company}
						setCompany={setCompany}
						user={user as FrontendUserInfo}
						orgDetailsSelectedCategory={orgDetailsSelectedCategory}
						organizationId={selectedOrganization.organizationId}
						orgSpecifications={orgSpecifications}
						setOrgSpecifications={setOrgSpecifications}
						specDirectories={specDirectories}
						setSpecDirectories={setSpecDirectories}
					></OrgSpecificationsSection>
				</div>
			)}
		</div>
	);
}
